import { Box } from "@mui/material";
import AppSidebar from "../components/AppSidebar";
import { AuthContextProvider } from "../context/authContext";
import { msalInstance } from "../utils/msal";
import { MsalProvider } from "@azure/msal-react";
import { Outlet, useLocation } from "react-router-dom";
import { Schedule4DProvider } from "../pages/client/AllEquipments/CommonFeatures/MCS3/Schedule4D/Schedule4DContext";
import ModuleRouteGuard from "../components/RoutesHandler/ModuleRouteGuard";
import { EmsSidePanelProvider } from "../context/EmsSidePanelContext";
import paths from "../api/paths.api";

export const GlobalOutlet = () => {
  return (
    <AuthContextProvider>
      <MsalProvider instance={msalInstance}>
        <Outlet />
      </MsalProvider>
    </AuthContextProvider>
  );
};

export const Layout = () => {
  const { pathname } = useLocation();
  const isEmsExplorerPage = pathname.startsWith(paths.emsExplorer);

  return (
    <Schedule4DProvider>
      <EmsSidePanelProvider>
        <Box sx={{ display: "flex", height: "100vh" }}>
          <AppSidebar hideProjectsTree={isEmsExplorerPage} />
          <Box sx={{ flexGrow: 1, minWidth: 0, height: "100%", overflow: "auto" }}>
            <ModuleRouteGuard>
              <Outlet />
            </ModuleRouteGuard>
          </Box>
        </Box>
      </EmsSidePanelProvider>

      {/* <Footer /> */}
    </Schedule4DProvider>
  );
};
